import { createRequest } from "helpers/tools";

export const getOpenAiAdsConversions = async (destinationId) => {
    return await createRequest({
        suffix: `destinations/openai-ads/${destinationId}/conversions`,
        handleError: false,
        method: "get",
    });
};

export const getOpenAiAdsMappings = async (destinationId) => {
    return await createRequest({
        suffix: `destinations/openai-ads/${destinationId}/mappings`,
        handleError: false,
        method: "get",
    });
};

export const postOpenAiAdsMappings = async (destinationId, payload) => {
    return await createRequest({
        suffix: `destinations/openai-ads/${destinationId}/mappings`,
        handleError: false,
        method: "post",
        payload,
    });
};

const getCreatedDestinationList = (response) => {
    const created = response?.data?.data ?? response?.data;
    if (Array.isArray(created)) {
        return created;
    }
    if (created && (created.id || created.destination_id)) {
        return [created];
    }
    return [];
};

const destinationIdOf = (destination) =>
    destination?.id ?? destination?.destination_id ?? null;

export const getCreatedOpenAiDestinationIds = (response) => {
    const created = getCreatedDestinationList(response);
    const conversion =
        created.find((item) => item?.destination_type?.code === "oaicapi") ??
        created[0];
    const pixel =
        created.find((item) => item?.destination_type?.code === "oaipixel") ??
        created[1];
    const conversionId = destinationIdOf(conversion);
    const pixelId = destinationIdOf(pixel);

    return {
        conversionId,
        pixelId: pixelId && pixelId !== conversionId ? pixelId : null,
    };
};

export const getCreatedDestinationId = (response) =>
    getCreatedOpenAiDestinationIds(response).conversionId;
